import React from "react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import vigezo_masharti from "../components/documents/vigezo_masharti.pdf";
import { Modal, Form } from "react-bootstrap";
import Header from "./layout/Header";
import { createNotification } from "./Popup";
import { getAppId, getDeclarationInfo, getdob, getEmail, setTStageID } from "../utility/Common";
import { applicationManagement, url } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import DeclarationReusableComponent from "./declarationReusableComponent";
import CentryReusableComponent from "./CentryReusableComponent";

function SelfeDeclaration() {

  let applicantDoB = getdob();
  var d1 = new Date();
  var BellowAge = d1.getUTCFullYear() - applicantDoB;

  let appId = getAppId();
  let navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const handleModalToggle = () => {
    setShowModal(!showModal);
  };
  const { checkApplicationStage } = CentryReusableComponent({});
  const [formData, setFormData] = useState({
    ApplicationId: getAppId(),
    EmailAddress: getEmail(),
  });

  const [agree, setAgree] = useState(false);
  const handleChange = (e) => {
    const data = { ...formData };
    data[e.target.name] = e.target.value;
    setFormData(data);
    setAgree(!agree);
  };
  let uselocationData = useLocation()?.state;
  const [fomu, setFomu] = useState([]);
  const [photo, setPhoto] = useState([]);
  const [bioDataInfo, setBioDataInfo] = useState({});
  const [emargenceInf0, setEmargenceInf0] = useState({});
  const [emargenceInf1, setEmargenceInf1] = useState({});
  const [otherDetails, setOtherDetails] = useState({});
  const [fatherInfo, setFatherInfo] = useState({});
  const [motherInfo, setMotherInfo] = useState({});
  const [isLoading, setIsloading] = useState(false);
  const [isAddressCheck, setIsAddressCheck] = useState(false);
  const [attachmentInfo, setAttachmentInfo] = useState({});
  const modalStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    overflow: "hidden",
  };
  const { isdeclarationLoading, handleApplicationManagement } =
    DeclarationReusableComponent({
      applicationManagement,
    });

  const closeButtonStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "none",
    border: "none",
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "red",
    cursor: "pointer",
  };
  const handleSubmit = (e) => {
    setIsloading(true);
    e.preventDefault();
    btnHandler();
    applicationManagement(formData, "declare").then(
      (result) => {
        setIsloading(false);
        if (result.code == 1) {
          if (result.data) {
            const stID = result.data[0]?.StageID
            setTStageID(stID)
            navigate("/stp10");
          }
          navigate("/stp10");
        } else if (
          result.code === 3 ||
          result?.message?.toLowerCase().includes("expire")
        ) {
          navigate("/");
          createNotification({ type: "error", message: "Session expired" })();

        } else if (
          result.code === 3 ||
          result?.message?.toLowerCase().includes("expire")
        ) { } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      },
      (error) => {
        setIsloading(false);

        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      }
    );
  };

  useEffect(() => {
    checkApplicationStage(1)
    getDeclarationInfoFromStorage();
  }, []);


  function getDeclarationInfoFromStorage() {
    const allData = getDeclarationInfo();
    setBioDataInfo(allData?.BioData && allData?.BioData[0]);
    setFatherInfo(allData?.ParentsData && allData?.ParentsData[0]);
    setMotherInfo(allData?.ParentsData && allData?.ParentsData[1]);
    setEmargenceInf0(allData?.EmergencyData && allData?.EmergencyData[0]);
    setEmargenceInf1(allData?.EmergencyData && allData?.EmergencyData[1]);
    setOtherDetails(allData?.OtherDetails && allData?.OtherDetails[0]);
    setAttachmentInfo(allData?.AttachmentInfo && allData?.AttachmentInfo[0]);
  }
  const btnHandler = () => { };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getAddresInfo = () => {
    setIsAddressCheck(true);
    const payload = {
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      TravellingPurposeID: "",
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    handleApplicationManagement(payload, "add-address-info");
  };

  const getTravelInfo = () => {
    setIsAddressCheck(true);
    const payload = {
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      TravellingPurposeID: "",
      CountryID: "",
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    handleApplicationManagement(payload, "add-travel-info");
  };

  const endeleaBadae = () => {
    navigate("/");
  };
  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content p-0">
            <div className="btn-group btn-breadcrumb breadcrumb-primary">
              <Link
                to="/"
                className="btn btn-primary visible-lg-block visible-md-block"
                style={{ textDecoration: "none" }}
              >
                <b>
                  <i className="fa fa-home" aria-hidden="true"></i> &nbsp;
                  Ukurasa Wa Mwanzo
                </b>
              </Link>
              <Link
                to="/"
                className="btn btn-primary visible-lg-block visible-md-block"
                style={{ textDecoration: "none" }}
              >
                <b>Nambari ya Ombi: &nbsp;{appId}</b>
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "1px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    className="list-group-item done"
                  >
                    Habari Binafsi
                  </Link>
                  <Link
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link
                    className="list-group-item done"
                  >
                    Habari za Wazazi
                  </Link>
                  <Link
                    className="list-group-item done"
                  >
                    Habari za Safari
                  </Link>
                  <Link
                    className="list-group-item done"
                  >
                    Wakati wa Dharura
                  </Link>
                  <Link
                    className="list-group-item done"
                  >
                    Viambatanisho
                  </Link>
                  <Link className="list-group-item active">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Kamilika </Link>
                </div>
              </div>

              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-six-form" onSubmit={handleSubmit}>
                    <input type="hidden" name="_csrf" value="" />
                    <div className="card">
                      <div className="box panel panel-default">
                        <div className="callout callout-warning">
                          <p style={{ fontSize: "13px" }}>
                            <strong>ZINGATIA:</strong> Tafadhali hakiki kwa
                            makini taarifa ulizojaza kabla ya kuzithibitisha.
                            Kumbuka, hautoweza kubadilisha taarifa baada ya
                            kuvuka hatua hii.
                          </p>
                        </div>

                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-user"></i>{" "}
                            <h3 className="box-title">Habari Binafsi</h3>
                            <Link
                              className="btn pull-right btn-success btn-xs"
                              disabled={true}
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-10">
                                <div className="row">
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina la Kwanza
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.GivenNames}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina la Ukoo
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.Surname}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-2">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Jinsia</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.Gender}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-3">
                                      <span style={{ lineHeight: "1.7em" }}>
                                        <b style={{ fontSize: "13px" }}>
                                          Habari ya Ndoa
                                        </b>
                                        <br />

                                        <p
                                          style={{
                                            fontSize: "13px",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {bioDataInfo?.MaritalStatus}
                                        </p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <br />
                                <br />
                                <div className="row">
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Namba ya Uraia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.Nin}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kitambulisho cha Mzanzibari
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.ZanzibarID}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>


                              <div className="col-sm-2 declaration-div">
                                {bioDataInfo?.PhotoImage ? (
                                  <img
                                    src={`data:image/jpg;base64,${bioDataInfo.PhotoImage}`}
                                    className="img-thumbnail center-block declaration-image"
                                    style={{ width: "120px", height: "140px" }}
                                  />
                                ) : (<>
                                  {attachmentInfo?.AttachmentPath ? (
                                    <img
                                      src={`${url}get_file?path=${attachmentInfo?.AttachmentPath}`}
                                      className="img-thumbnail center-block declaration-image"
                                      style={{
                                        width: "110px",
                                        height: "130px",
                                      }}
                                    />
                                  ) : (
                                    <p>No image available</p>
                                  )}</>
                                )}


                              </div>


                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Tarehe na Mahali pa Kuzaliwa</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Tarehe ya Kuzaliwa
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.DateofBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.CountryOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.TerritoryOfBirth}
                                      </p>
                                    </span>
                                  </div>

                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.RegionalOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.DistrictOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.DistrictOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.VillageOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <br />
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-address-book"></i>{" "}
                            <h3 className="box-title">Anuwani ya Makazi</h3>
                            <Link
                              onClick={() => getAddresInfo()}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Mawasiliano</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.MobileNo}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Barua pepe
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {bioDataInfo?.Email}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />

                                <div className="strike">
                                  <span>Anuani ya Makazi</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.RegionName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.DistrictName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.VillageName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.HouseNumber}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-users"></i>{" "}
                            <h3 className="box-title">Habari za Wazazi</h3>
                            <Link
                              disabled={true}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Habari za Baba</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.ParentName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Tarehe ya Kuzaliwa
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.DateOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.CountryOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.Territory}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.RegionOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.DistrictOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.WardOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {fatherInfo?.WardOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="strike">
                                  <span>Habari za Mama</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.ParentName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Tarehe</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.DateOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.CountryOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.Territory}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.RegionOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.DistrictOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.WardOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {motherInfo?.VillageOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-plane"></i>{" "}
                            <h3 className="box-title">Habari za Safari</h3>
                            <Link
                              onClick={() => getTravelInfo()}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Madhumuni ya Safari</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Dhumuni la Safari
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.TravellingPurpose}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-6">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nchi unayokwenda
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.TravellingCountryName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kazi yako
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {otherDetails?.Occupation}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* ====================Bellow Gurdian================== */}
                          <div>
                            {BellowAge >= 18 ? (
                              <p></p>
                            ) : (
                              <div className="box-body panel-body">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="strike">
                                      <span>
                                        Mzazi / Mlezi (kwa waombaji waliochini
                                        ya umri wa miaka 18)
                                      </span>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Jina kamili
                                          </b>
                                          <br />
                                          {fomu?.map((obj) => (
                                            <p
                                              style={{
                                                fontSize: "13px",
                                                textTransform: "uppercase",
                                              }}
                                            >
                                              {obj?.travel_purpose}
                                            </p>
                                          ))}
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Kazi
                                          </b>
                                          <br />
                                          {fomu?.map((obj) => (
                                            <p
                                              style={{
                                                fontSize: "13px",
                                                textTransform: "uppercase",
                                              }}
                                            >
                                              {obj?.CountryTotravel}
                                            </p>
                                          ))}
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Anuani
                                          </b>
                                          <br />
                                          {fomu?.map((obj) => (
                                            <p
                                              style={{
                                                fontSize: "13px",
                                                textTransform: "uppercase",
                                              }}
                                            >
                                              {obj?.CountryTotravel}
                                            </p>
                                          ))}
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Simu ya Mkononi
                                          </b>
                                          <br />
                                          {fomu?.map((obj) => (
                                            <p style={{ fontSize: "13px" }}>
                                              {obj?.CountryTotravel}
                                            </p>
                                          ))}
                                        </span>
                                      </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Uhusiano
                                          </b>
                                          <br />
                                          {fomu?.map((obj) => (
                                            <p
                                              style={{
                                                fontSize: "13px",
                                                textTransform: "uppercase",
                                              }}
                                            >
                                              {obj?.travel_purpose}
                                            </p>
                                          ))}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* ========= */}
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-ambulance"></i>{" "}
                            <h3 className="box-title">Wakati wa Dharura</h3>
                            <Link
                              disabled={true}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Mtu wa Kwanza wakati wa Dharura</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.EmergencyName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Kazi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.Profession}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Sanduku la Posta
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.PoBox}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.MobileNo}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mji</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.ResidenceTown}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mtaa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.ResidenceStreet}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.VillageOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Uhusiano
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf0?.RelationShip}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="strike">
                                  <span>Mtu wa Pili wakati wa Dharura</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.EmergencyName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Kazi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.Profession}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Sanduku la Posta
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.PoBox}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.MobileNo}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mji</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.ResidenceTown}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mtaa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.ResidenceStreet}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.VillageOfBirth}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Uhusiano
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {emargenceInf1?.RelationShip}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <Modal
                          show={show}
                          onHide={handleClose}
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                          style={modalStyle}
                        >
                          <Modal.Header>
                            <Modal.Title>
                              <h5 className="modal-title">Modal Title</h5>
                            </Modal.Title>
                            <button
                              type="button"
                              onClick={handleClose}
                              style={closeButtonStyle}
                            >
                              &times;
                            </button>
                          </Modal.Header>

                          <Modal.Body>
                            <Form.Group
                              className="position-relative mb-3"
                              id="photo"
                            >
                              <center>
                                <img
                                  src={photo}
                                  width="420px"
                                  height="250px"
                                  alt="Modal content"
                                />
                              </center>
                            </Form.Group>
                          </Modal.Body>

                          <Modal.Footer />
                        </Modal>

                        <div className="alert alert-info">
                          <button
                            type="button"
                            className="showModalButton btn btn-xs btn-primary pull-right"
                            value="VigezoMasharti"
                            title="Masharti Na Vigezo"
                            onClick={handleModalToggle}
                          >
                            Vigezo na Masharti
                          </button>
                          <p style={{ fontSize: "13px" }}>
                            <strong>ANGALIZO:</strong>&nbsp;tafadhali soma kwa
                            makini vigezo na masharti kabla ya kukubali
                            kuendelea na Ombi ili kuepuka usumbufu baadae.
                          </p>
                        </div>
                        <div
                          className="form-group field-isdeclared"
                          style={{ padding: "5px" }}
                        >
                          <div className="checkbox">
                            <label htmlFor="isdeclared">
                              <input
                                type="checkbox"
                                id="isdeclared"
                                name="StageID"
                                onChange={(e) => handleChange(e)}
                              />
                              <p style={{ fontSize: "13px" }}>
                                Nimehakikisha kuwa taarifa nilizojaza zipo sawa,
                                na nimeelewa vigezo na masharti.
                              </p>
                            </label>
                            <p className="help-block help-block-error"></p>
                          </div>
                        </div>
                        <div className="box-footer">
                          <div className="row">
                            <div className="col-md-4">
                              <Link
                                onClick={() => getTravelInfo()}
                                className="btn btn-default btn-block btn-label-next"
                              >
                                <i className="fa fa-angle-double-left"></i> |
                                Hatua Iliyotangulia
                              </Link>
                            </div>
                            <div className="col-md-4">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  endeleaBadae();
                                }}
                                className="btn btn-labeled btn-block btn-default"
                              >
                                Endelea Baadae |{" "}
                                <i className="fa fa-sign-out"></i>
                              </Link>
                            </div>
                            <div className="col-md-4">
                              <button
                                type="submit"
                                className="btn btn-default btn-block btn-label-next"
                                name="SaveNext"
                                disabled={!agree}
                                onClick={handleSubmit}
                              >
                                Hifadhi na Endelea |{" "}
                                <i className="fa fa-angle-double-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <p className="pull-right p-t-5 ftStyle">
            Support Email:{" "}
            <a href="mailto:passporttanzania@immigration.go.tz">
              passporttanzania@immigration.go.tz
            </a>
          </p>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show popModal"
        >
          <div
            className="modal-content mdContent"
          >
            <div className="modal-header">
              <h5 className="modal-title">Muongozo wa Maombi ya ETD</h5>
              <button
                type="button"
                className="close"
                onClick={handleModalToggle}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body mdBody"
            >
              <iframe
                src={vigezo_masharti}
                title="Guidelines PDF"
                className="mdIframe"
              ></iframe>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleModalToggle}>
                Funga
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SelfeDeclaration;
